/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="71.17"
        height="91.57"
        viewBox="0 0 71.17 91.57"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M1.44 17.17a17.48 17.48 0 0 1 33.06 2.9 1.25 1.25 0 0 1-2.43.58 15 15 0 1 0-15.82 18.4 1.25 1.25 0 1 1-.2 2.49A17.51 17.51 0 0 1 1.44 17.17Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M28.87 13.75a1.25 1.25 0 0 1 1.63 1.89l-.1.09-7.85 6.05a1.24 1.24 0 0 1-1.75-.23 1.23 1.23 0 0 1 .12-1.66l.1-.09ZM11.95 23.8a1.24 1.24 0 0 1 1.44 1 1.26 1.26 0 0 1-.89 1.45h-.12l-9.71 1.7a1.25 1.25 0 0 1-.55-2.43h.12ZM13.64 28.1a1.25 1.25 0 0 1 2.21 1.15l-.06.12-5 8.39a1.25 1.25 0 0 1-1.71.43 1.26 1.26 0 0 1-.5-1.6l.07-.12ZM4.97 13.5a1.25 1.25 0 0 1 1.65-.25l.11.08 7.41 6.29a1.25 1.25 0 0 1-1.5 2l-.11-.09-7.42-6.28a1.25 1.25 0 0 1-.14-1.75ZM17.64 7.68a1.24 1.24 0 0 1 1.23 1.13v.13l-.09 9.71a1.251 1.251 0 0 1-2.5.11v-.13l.09-9.72a1.24 1.24 0 0 1 1.27-1.23Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M21.87 25.25a1.26 1.26 0 0 1 1.28 1.07v.13l1.17 29.44 3.53 6.71a1.26 1.26 0 0 1 .13.37v.13l1.76 26H44a1.24 1.24 0 0 1 1.25 1.09v.13a1.24 1.24 0 0 1-1.12 1.24H28.59a1.25 1.25 0 0 1-1.23-1v-.13l-1.83-26.92-3.55-6.73a1.34 1.34 0 0 1-.13-.4v-.13l-1.18-29.72a1.25 1.25 0 0 1 1.2-1.28Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M67.63 25.25a1.25 1.25 0 0 1 1.2 1.17v.13l-1.17 29.7a1.37 1.37 0 0 1-.09.4v.13l-3.55 6.73L62.2 90.4a1.23 1.23 0 0 1-1.11 1.16H43.85a1.25 1.25 0 0 1-.12-2.49h16l1.75-26a1.24 1.24 0 0 1 .09-.38l.06-.12 3.53-6.72 1.16-29.43a1.25 1.25 0 0 1 1.17-1.2Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M66.92 43.67a1.25 1.25 0 0 1 .13 2.49H22.57a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h44.47Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M64.68.14a1.25 1.25 0 0 1 1.26 2.11l-.11.07L53.1 8.94v35.4a1.27 1.27 0 0 1-1.13 1.25h-.12a1.26 1.26 0 0 1-1.25-1.12V8.18a1.26 1.26 0 0 1 .55-1l.12-.07ZM35.63 57.8a1.25 1.25 0 0 1 1.28 1.09v.12l.75 23.51a1.25 1.25 0 0 1-2.48.2v-.12l-.75-23.51a1.26 1.26 0 0 1 1.2-1.29ZM53.86 57.8a1.25 1.25 0 0 1 1.21 1.16v.13l-.75 23.5a1.25 1.25 0 0 1-2.49 0v-.12l.74-23.51a1.26 1.26 0 0 1 1.29-1.16ZM44.75 57.7a1.24 1.24 0 0 1 1.24 1.12v23.71a1.252 1.252 0 0 1-2.5.13V58.95a1.25 1.25 0 0 1 1.26-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M69.92 25.25a1.25 1.25 0 0 1 .12 2.49H51.97a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.24h18.07Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M51.42 25.25a1.25 1.25 0 0 1 .13 2.49H19.49a1.252 1.252 0 0 1-.13-2.5h32.06Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M38.12 25.25a1.25 1.25 0 0 1 .13 2.44H19.49a1.252 1.252 0 0 1-.13-2.5h18.76Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DrinkingGlassWithStrawAndLemonWheelIcon';

export default Icon;
